<div  [ngClass]="webView ? '' : 'smooth-scrolling'">
    <div class="modal-content need-help-d">
        <div class="modal-body">
            <div class="support-detail">
                <div *ngIf="!webView" (click)="goBack()" class="support-icon">
                    <img  src="assets/images/profile-left-icon.svg" alt="icon">
                </div>
                <span>Customer support</span>
            </div>
    
           <div class="customer-detail mb-3">
                <a href="//api.whatsapp.com/send?phone=9920072227&text=Hello Foy" class="w-100" target="_blank">
                    <div class="customer-detail-section">
                        <div class="customer-detail">
                            <div class="customer-img">
                                <img src="assets/images/whatsapp-icon.png" alt="icon">
                            </div>
                            <div class="customer-text">
                                <span>Chat with us</span>
                                <p>Connect with us on whatsapp</p>
                            </div>
                        </div>
                        <div class="icon-customer" *ngIf="receivedData && receivedData?.data == true">
                            <img src="assets/images/profile-right-icon.svg" alt="icon">
                        </div>
                    </div>
                </a>
           </div>
            <div class="customer-detail mb-3">
               <a href="mailto:customerdelight@foyforyou.com" class="w-100">
                <div class="customer-detail-section">
                    <div class="customer-detail">
                        <div class="customer-img mail">
                            <img src="assets/images/mail-icon.svg" alt="icon">
                        </div>
                        <div class="customer-text ">
                            <span>Email Us</span>
                            <p>Write to us over an E-mail</p>
                        </div>
                    </div>
                    <div class="icon-customer" *ngIf="receivedData && receivedData?.data == true">
                        <img src="assets/images/profile-right-icon.svg" alt="icon">
                    </div>
                </div>
               </a>
            </div>
            <div class="customer-detail mb-3">
                <a href="tel:+919920072227" class="w-100">
                    <div class="customer-detail-section">
                        <div class="customer-detail">
                            <div class="customer-img">
                                <img src="assets/images/phone-icon.png" alt="icon">
                            </div>
                            <div class="customer-text">
                                <span>Call Us</span>
                                <p>Monday to Friday. 10 am to 7 pm</p>
                            </div>
                        </div>
                        <div class="icon-customer" *ngIf="receivedData && receivedData?.data == true">
                            <img src="assets/images/profile-right-icon.svg" alt="icon">
                        </div>
                    </div>
                </a>
            </div>
        </div>
    </div>
</div>
